module.exports = __webpack_public_path__ + "img/Realisme_Fra_romantikk_til_realisme2.4938ea71.jpg";